import createTitleFabric from "../../../general/CoreHeader/components/Title/titleFabric";
import { createDisplayNameForHeader } from "../../utils/createDisplayName";
import { createTestIdForHeader } from "../../utils/createTestId";

const displayName = createDisplayNameForHeader("Title");
const testId = createTestIdForHeader("title");

const HeaderTitle = createTitleFabric(displayName, testId);

export default HeaderTitle;
